import React, {useState} from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Column from '../../../bootstrap/component/Column'
import Row from '../../../bootstrap/component/Row'
import IPRInstructionList from './IPRInstructionList'
import {IPR_NOT_REQUIRED, IS_IPR_INSTRUCTIONS_LIST_SAVED} from '../../state/plan/const'
import currentUserHasAccess from '../../../../util/widget-helper'
import {IPR_INSTRUCTIONS_WIDGET} from '../../../process/ui-definition/process-ui'
import SelectChip from '../../../form/component/SelectChip';

const IPR_NOT_NEEDED_VALUE = [
    {
        value: false,
        label: 'IPR needed',
    },
    {
        value: true,
        label: 'IPR not needed',
    },
];

const IPRInstructions = ({
                             treatmentPlan,
                             context,
                             readOnly,
                             isWidget,
                             changeTreatmentPlan,
                             changeIPRInstruction,
                             saveTreatmentPlan,
                             changeProcessContext,
                             saveProcessContext,
                             isIPRProviderStore
                         }) => {

    const [isVisible, setIsVisible] = useState(false);

    if (!currentUserHasAccess(IPR_INSTRUCTIONS_WIDGET)) {
        return null
    }

    if (!isIPRProviderStore) {
        return null;
    }

    const {iprInstructionList} = treatmentPlan;

    const iprNotDecided = context[IPR_NOT_REQUIRED] === undefined;
    const iprNotRequired = context[IPR_NOT_REQUIRED];

    // workaround for Reduce Enamel task where we are not going to edit this values
    // but the value must be displayed properly
    const vContext = {
        ...context,
    }

    if (readOnly && iprNotDecided) {
        vContext[IPR_NOT_REQUIRED] = !iprInstructionList;
    }

    // workaround for inconsistent data, when we have instructions,
    // but don't have IPR_NOT_REQUIRED in context
    // to be removed when
    if (isWidget && iprNotDecided && iprInstructionList) {
        changeProcessContext(IPR_NOT_REQUIRED, false);
        saveProcessContext();
        vContext[IPR_NOT_REQUIRED] = false;
        context[IS_IPR_INSTRUCTIONS_LIST_SAVED] = false
    }

    const toggleEditButtons = () => {
        setIsVisible(!isVisible)
    }

    const ButtonGroup = () => {

        const btnStyle = {
            marginRight: '10px'
        }

        const onCancel = () => {
            toggleEditButtons()
        }

        const onSave = () => {
            saveTreatmentPlan()
            toggleEditButtons()
            context[IS_IPR_INSTRUCTIONS_LIST_SAVED] = true;
        }

        return (
            <React.Fragment>
                <button
                    className="btn btn-primary pull-right"
                    onClick={onSave}>
                    Save
                </button>
                <button
                    className="btn btn-default pull-right"
                    style={btnStyle}
                    onClick={onCancel}>
                    Cancel
                </button>
            </React.Fragment>
        )
    }

    return (
        <div className="additional-instructions">
            <ContentBox title="IPR(ASR) instructions">
                <Row>
                    <Column size={12}>
                        {!isVisible && !iprNotRequired && !readOnly && !iprNotDecided &&
                            <button
                                className="btn btn-primary pull-right"
                                onClick={toggleEditButtons}>
                                <span className="fa fa-edit" aria-hidden="true"/>
                            </button>
                        }
                        {isVisible &&
                            <ButtonGroup/>
                        }
                    </Column>
                </Row>
                {isWidget && (
                    <SelectChip
                        object={vContext}
                        name={IPR_NOT_REQUIRED}
                        readOnly={readOnly}
                        addEmpty={true}
                        valueList={IPR_NOT_NEEDED_VALUE}
                        onChange={(name, value) => {
                            if (value) {
                                changeTreatmentPlan('iprInstructionList', null);
                                context[IS_IPR_INSTRUCTIONS_LIST_SAVED] = false
                            } else {
                                changeTreatmentPlan('iprInstructionList', {});
                            }
                            saveTreatmentPlan()
                            changeProcessContext(name, value)
                            saveProcessContext()
                        }}
                    />
                )}
                <Row top="M">
                    <Column size={12}>
                        <IPRInstructionList
                            readOnly={readOnly || iprNotRequired || iprNotDecided || !isVisible}
                            changeIPRInstruction={changeIPRInstruction}
                            iprInstructionList={iprInstructionList}/>
                    </Column>
                </Row>
            </ContentBox>
        </div>
    )
}

IPRInstructions.propTypes = {
    treatmentPlan: PropTypes.shape({
        iprInstructionList: PropTypes.object,
        iprPossible: PropTypes.bool,
    }).isRequired,
    isWidget: PropTypes.bool,
    readOnly: PropTypes.bool,
    saveTreatmentPlan: PropTypes.func.isRequired,
    changeIPRInstruction: PropTypes.func.isRequired,
    changeProcessContext: PropTypes.func,
    saveProcessContext: PropTypes.func,
    context: PropTypes.object,
}


export default IPRInstructions



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/IPRInstructions.js